import {Component, Inject, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {SnackBarService} from '@core/services/snack-bar.service';

@Component({
    standalone: false,
    selector: 'particle-create-custom-form-dialog',
  templateUrl: './create-custom-form-dialog.component.html',
  styleUrls: ['./create-custom-form-dialog.component.scss']
})
export class CreateCustomFormDialogComponent implements OnInit, IDialogView {
  inputForm: FormGroup;
  data: DialogModel;
  constructor(private formBuilder: FormBuilder, private snackBarService: SnackBarService) {

  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      title: [this.data.input.title, Validators.required],
      isTabbedForm: [false]
    });
  }
  onOkClicked(): boolean {
    const title = this.inputForm.controls['title'].value;
    console.log('title: ', title);
    const isTabbedForm = this.inputForm.controls['isTabbedForm'].value;
    let viewType = 'Group';
    if (isTabbedForm) {
      viewType = 'Tab';
    }
    console.log('viewType: ', viewType);
    if (!this.inputForm.valid) {
      this.snackBarService.showError('Please fill up necessary fields.');
      return false;
    }
    this.data.input.title = title;
    this.data.input.viewType = viewType;
    return true;
  }

}
